import React, { Component, createRef } from "react";
import {
  addDays,
  addMonths,
  differenceInCalendarDays,
  format,
  isAfter,
  isSameDay,
} from "date-fns";
import cf from "../../../../lib/utils/common";
import AutoComplete from "./AutoComplete";
import DesktopCalender from "./DesktopCalender";
import PickupTime from "./PickupTime";
import DistanceList from "./DistanceList";
import AirportTransferSelector from "./AirportTransferSelector";
import TimePicker from "./TimePicker";
import moment from "moment";
import B2BWidgets from "@/commonComponents/b2bwidgets";
import { leadingSpaces } from "../../../../lib/utils/regex_cheat_sheet";
import TripTypeSelector from "../../../../components/TripTypeSelector/theme4/index.js";

const weekday = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

let TripType = [
  { id: 1, value: "oneWay", label: "Outstation One-Way" },
  { id: 2, value: "roundTrip", label: "Outstation Round-Trip" },
  { id: 3, value: "airport", label: "Airport Transfers" },
  { id: 4, value: "hourly", label: "Hourly Rentals" },
];

let TripTypeMobile = [
  { id: 1, value: "oneWay", label: "One Way" },
  { id: 2, value: "roundTrip", label: "Round Trip" },
  { id: 3, value: "airport", label: "Airport Transfers" },
  { id: 4, value: "hourly", label: "Hourly Rentals" },
];

const todaysDate = format(new Date(), "dd-LLL-yyyy");
let curTime = moment();
let roundedMinutes = Math.ceil(curTime.minute() / 5) * 5;
curTime.minute(roundedMinutes).seconds(0);
curTime.add(15, "minutes");
const currentTime = curTime.format("hh:mm A");
// let currentTime = moment().format("hh:mm A")

export default class Theme5 extends Component {
  constructor(props) {
    super(props);
    this.setState = this.setState.bind(this);
    this.guestDetailWrapper = createRef();
    this.economyPopUpWrapper = createRef();
    this.advanceSearchWrapper = createRef();
    this.passengerDropdownWrapper = createRef();
    this.travellerCabin = createRef();
    this.multicityDepartureWrapper = createRef();
    this.multicityReturnWrapper = createRef();
    this.multicityClassWrapper = createRef();
    this.departureListWrapper = createRef();
    this.stopsWrapper = createRef();
    this.returnListWrapper = createRef();
    this.setDropdownWrapperRef = createRef();
    this.box = createRef(null);
    this.state = {
      showMulticitySrp: false,
      departureAirPortName: "",
      goingToAirPortName: "",
      isOnewaySearch: true,
      departureValue: "",
      goingToValue: "",
      expandDepartureBoolean: false,
      expandGoingToBoolean: false,
      departureDateValue: format(new Date(), "dd-LLL-yyyy"),
      goingToDateValue: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
      expandDepartureDateBoolean: false,
      expandGoingToDateBoolean: false,
      paxAdultValue: 1,
      paxChildrenValue: 0,
      paxInfantValue: 0,
      SelectedClassValue: { label: "Economy", id: 1 },
      openCabinClassList: false,
      getDepartureSuggestionList: [],
      getGoingToSuggestionList: [],
      getDepartureAirportCode: "",
      getGoingToAirportCode: "",
      openCabinClassListOne: false,
      isError: {
        departure: false,
        goingTo: false,
        departureDate: false,
        goingToDate: false,
        pickTime: false,
        dropTime: false,
        colleagueError: false,
      },
      returnCity: "",
      departureCity: "",
      isMultiCitySearch: false,
      openPaxList: false,
      guest_id: "",
      travellerCabinClass: { label: "Economy", id: 1 },
      FareTypeOption: "",
      travellerCabin: false,
      selectedTripType: 3,
      showTraveller: false,
      pax: {
        adults: 1,
        child: 0,
        infants: 0,
      },
      isAdvanceSearch: false,
      nonStopflag: "",
      tripTypeArr: [...TripType],
      tabs: [
        {
          id: 0,
          label: "Outstation Cabs",
          tripOptions: TripTypeMobile.slice(0, 2),
        },
        { id: 3, label: "Airport Cabs", tripOptions: [TripTypeMobile[2]] },
        { id: 4, label: "Hourly Rentals", tripOptions: [TripTypeMobile[3]] },
      ],
      commomErrorMsg: "",
      toRecent: [],
      fromRecent: [],
      stopsRecent: [],
      btnClicked: false,
      faretypelist: [],
      stops: "",
      stopsValue: "",
      isdepartureCalendarVisible: false,
      isreturnCalendarVisible: false,
      checkInOutValue: "",
      departureDate: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      returnDate: cf.getDateWithFormat(
        addDays(
          new Date(),
          this.props.getDefaultDays ? this.props.getDefaultDays : 2
        ),
        this?.props?.dateFormat
      ),
      dateLimit: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      showsrcDropdown: false,
      showdestDropdown: false,
      showstopsDropdown: false,
      showdatepickupDropdown: false,
      showdatedropDropdown: false,
      showdistanceDropdown: false,
      src: "",
      srcValue: "",
      dest: "",
      destValue: "",
      disabledDate: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      selectedTab: 3,
      selectedDestinations: [],
      showAutoComplete: false,
      errorMessage: {
        addStopsErr: "",
        srcErr: "",
        destErr: "",
        dropTime: "",
        pickTime: "",
      },
      packageId: 1,
      time: currentTime,
      dropTime: currentTime,
      distance: "",
      tripTypeDetails: {},
      type: "car",
      openTraveler: false,
      selectedGuest: false,
      selectedNationality: { value: "", countryCode: null },
      clientNationality: { value: "", countryCode: null },
      isguestChecked: this.props?.isguestChecked || false,
      employeeguestId: [],
      bookingTripId: "",

    };
    this.box = createRef(null);
  }
  componentDidMount() {
    if (this.props.isSRP) {
      this.setState({
        src: this.props.carQuery?.from?.name,
        dest: this.props.carQuery?.to?.name || "",
        departureDate: this.props?.carQuery?.fromDate,
        returnDate: this.props?.carQuery?.toDate || "",
        srcValue: this.props?.carQuery?.from,
        destValue: this.props?.carQuery?.to || "",
        time: this.props?.carQuery?.pickupTime || "",
        dropTime: this.props?.carQuery?.dropTime || "",
        distance: this.props?.carQuery?.distance || "",
        packageId: this.props?.carQuery?.packageId || 1,
        selectedTripType: this.props?.carQuery?.tripType || 1,
        selectedTab: this.props?.carQuery?.selectedTab,
        tripTypeDetails: this.props.carQuery?.tripTypeDetails || {},
        selectedDestinations: this.props.carQuery?.stops,
        bookingTripId: this.props.carQuery?.bookingType,
      });
    }
    this.setState({
      fromRecent: localStorage.getItem("from_recent_searchCar")
        ? JSON.parse(localStorage.getItem("from_recent_searchCar"))
        : [],
      toRecent: localStorage.getItem("to_recent_searchCar")
        ? JSON.parse(localStorage.getItem("to_recent_searchCar"))
        : [],
      // stopsRecent: localStorage.getItem("stop_recent_searchCar") ? JSON.parse(localStorage.getItem("stop_recent_searchCar")) : []
    });

    if (this.props?.userProfile?.type == "B2E") {
      this.setState({ guest_id: this.props?.userProfile?._id });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props?.userProfile != nextProps?.userProfile) {
      if (nextProps?.userProfile?.type == "B2E") {
        this.setState({ guest_id: nextProps?.userProfile?._id });
      }
    }
  }

  handleClickOutside = () => {
    if (
      !this.props.isMobile &&
      this.departureListWrapper.current &&
      !this.departureListWrapper.current.contains(event.target)
    ) {
      this.setState({ showsrcDropdown: false });
    }
    if (
      !this.props.isMobile &&
      this.returnListWrapper.current &&
      !this.returnListWrapper.current.contains(event.target)
    ) {
      this.setState({ showdestDropdown: false });
    }
    if (
      !this.props.isMobile &&
      this.stopsWrapper.current &&
      !this.stopsWrapper.current.contains(event.target)
    ) {
      this.setState({ showAutoComplete: false, showstopsDropdown: false });
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  onclickFlightAutoComplete(type) {
    this.setState((prevState) => ({
      showsrcDropdown: type === "src" ? true : false,
      showdestDropdown: type === "dest" ? true : false,
      showstopsDropdown: type === "stops" ? true : false,
      showdatepickupDropdown: type === "datePickup" ? true : false,
      showdatedropDropdown: type === "dateDrop" ? true : false,
      showdistanceDropdown: type === "distance" ? true : false,
      [`${type}`]: "",
      [`${type}Value`]: "",
    }));
    this.props.getAutoSuggestData(
      "",
      type == "src" ? "departure" : type == "stops" ? "stops" : "return",
      "click"
    );
  }

  expandAutoComplete = (bool, type) => {
    this.setState((prevState) => ({
      showsrcDropdown: type === "src" ? bool : false,
      showdestDropdown: type === "dest" ? bool : false,
      showstopsDropdown: type === "stops" ? true : false,
      showdatepickupDropdown: type === "datePickup" ? true : false,
      showdatedropDropdown: type === "dateDrop" ? true : false,
      showdistanceDropdown: type === "distance" ? true : false,
    }));
  };

  popupClosed = (type) => {
    this.setState({ [`show${type}Dropdown`]: false });
  };

  onClickSetDepartureGoingToValue = (value, type) => {
    if (type != "stops") {
      this.setState((prev) => ({
        [type]: value.name,
        [`${type}Value`]: value,
        showsrcDropdown: false,
        showdestDropdown: false,
        expandAutoCompleteBool: false,
        errorMessage: {
          ...prev.errorMessage,
          [`${type}Err`]: "",
        },
      }));
    } else {
      this.setState({ stops: value });
    }
  };

  onChangeSetDepartureGoingToValue = (value, type) => {
    var tripType = "";
    if (
      this.state.selectedTripType == 3 &&
      this.state.tripTypeDetails.value == "AIRPORT_PICKUP" &&
      type == "src"
    ) {
      tripType = "AIRPORT";
    } else if (
      this.state.selectedTripType == 3 &&
      this.state.tripTypeDetails.value == "AIRPORT_DROP" &&
      type == "dest"
    ) {
      tripType = "AIRPORT";
    }

    this.setState({ [type]: value.replace(leadingSpaces, "") }, () => {
      if (value.length > 2) {
        this.props.getAutoSuggestData(
          value.trim(),
          type == "src" ? "departure" : type == "stops" ? "stops" : "return",
          value ? "change" : "click",
          tripType ? tripType : ""
        );
      }
      this.setState((prevState) => ({
        showsrcDropdown: type === "src" ? true : false,
        showdestDropdown: type === "dest" ? true : false,
        showstopsDropdown: type === "stops" ? true : false,
      }));
    });
  };

  onChangeDepartureGoingDateValue = (value, type) => {
    let selectedDate = cf.getDateWithFormat(value, this?.props?.dateFormat);
    this.setState({ [`${type}Date`]: selectedDate });
    if (type === "departure" && moment(value).isSame(moment(), "day")) {
      this.apply("time", currentTime);
    }
    if (type === "return" && moment(value).isSame(moment(), "day")) {
      this.apply("dropTime", currentTime);
    }
    if (type === "departure" && this.state.selectedTripType === 2) {
      let departureDate = new Date(value);
      let currentDate = new Date();
      departureDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);
      let returnDate = new Date(this.state.returnDate);
      returnDate.setHours(0, 0, 0, 0);
      let dayDifference = differenceInCalendarDays(returnDate, departureDate);
      if (dayDifference < 0) {
        let oneYearLater = addMonths(currentDate, 12);
        if (
          isAfter(departureDate, oneYearLater) ||
          isSameDay(departureDate, oneYearLater)
        ) {
          let formattedNewReturnDate = cf.getDateWithFormat(
            value,
            this?.props?.dateFormat
          );
          this.setState({ returnDate: formattedNewReturnDate });
        } else {
          let newReturnDate = addDays(departureDate, 2);
          let formattedNewReturnDate = cf.getDateWithFormat(
            newReturnDate,
            this?.props?.dateFormat
          );
          this.setState({ returnDate: formattedNewReturnDate });
        }
      }
    }
    this.setState({ [`is${type}CalendarVisible`]: false });
    this.updateErrMsg();
  };

  onChangeVisibility = (bool, type) => {
    this.setState((prevState) => ({
      [type === "departure"
        ? "isdepartureCalendarVisible"
        : "isreturnCalendarVisible"]: bool,
    }));
    this.setState({ showsrcDropdown: false, showdestDropdown: false });
  };

  // onselectTrip = (trip, id) => {
  //   if (trip.id == 2) {
  //     let departureDate = new Date(this.state.departureDate);
  //     let currentDate = new Date();
  //     departureDate.setHours(0, 0, 0, 0);
  //     currentDate.setHours(0, 0, 0, 0);
  //     let oneYearLater = addMonths(currentDate, 12);
  //     if (isAfter(departureDate, oneYearLater) || isSameDay(departureDate, oneYearLater)) {
  //       this.setState({
  //         returnDate: cf.getDateWithFormat(
  //           addDays(new Date(this.state.departureDate), 0),
  //           this?.props?.dateFormat
  //         ),
  //       });
  //     } else {
  //       this.setState({
  //         returnDate: cf.getDateWithFormat(
  //           addDays(new Date(this.state.departureDate), 2),
  //           this?.props?.dateFormat
  //         ),
  //       });
  //     }
  //   }
  //   this.setState({ selectedTripType: trip.id });
  // };

  onselectTrip = (trip, id) => {
    if (trip.id === 2) {
      const { departureDate } = this.state;
      const { dateFormat } = this.props;
      const departure = new Date(departureDate);
      departure.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const oneYearLater = addMonths(today, 12);
      const daysToAdd =
        isAfter(departure, oneYearLater) || isSameDay(departure, oneYearLater)
          ? 0
          : 2;

      this.setState({
        returnDate: cf.getDateWithFormat(
          addDays(departure, daysToAdd),
          dateFormat
        ),
      });
    }

    this.setState({ selectedTripType: trip.id });
  };

  onChangeCheckInOutValue = (value, type) => {
    if (type === "startDate") {
      this.setState({ checkInValue: value });
    } else if (type === "endDate") {
      let differenceInDays = differenceInCalendarDays(
        new Date(value),
        new Date(this.state.checkInValue)
      );
      if (differenceInDays === 0) {
        this.setState({ checkOutValue: addDays(new Date(value), 1) }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(
                this?.state?.checkOutValue,
                this?.props?.dateFormat
              );
            this.setState({ checkInOutValue: checkInOut });
          }
        });
      } else {
        this.setState({ checkOutValue: value }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(value, this?.props?.dateFormat);
            this.setState({ checkInOutValue: checkInOut });
          }
        });
      }
    }
  };

  onInputFocus = (fieldName) => {
    if (fieldName == "calendar") {
      this.onClickVisibilityStatus("calendar", true);
      this.setState({ expandCheckInOutDateBoolean: true });
    }
  };

  onClickVisibilityStatus = (type, value) => {
    this.setState({ expandCheckInOutDateBoolean: value }, () => {
      if (
        this.props.expandHotelNameBoolean === true ||
        this.state.openRoomDetailList === true
      ) {
        this.setState({ openRoomDetailList: false });
        this.props.expandHotelNameBooleanfunc(false);
      }
    });
  };

  selectTab = (tab) => {
    if (tab.id == 0) {
      this.setState({ selectedTab: tab.id, selectedTripType: 1 });
    } else {
      this.setState({ selectedTab: tab.id, selectedTripType: tab.id });
    }
  };

  onClickSearchCar = () => {
    let isValid = this.checkValidation();
    let recentSearch = {
      from: {},
      to: {},
      stop: {},
    };

    if (isValid) {
      recentSearch.from = this.state.srcValue;
      recentSearch.to = this.state.destValue;
      recentSearch.stop = this.state.selectedDestinations;
      let filteredRecentSearches = localStorage?.getItem(
        "from_recent_searchCar"
      )
        ? JSON.parse(localStorage?.getItem("from_recent_searchCar"))
        : [];
      let filteredRecentSearchesTo = localStorage?.getItem(
        "to_recent_searchCar"
      )
        ? JSON.parse(localStorage?.getItem("to_recent_searchCar"))
        : [];
      let filteredRecentSearchesStops = localStorage?.getItem(
        "stops_recent_searchCar"
      )
        ? JSON.parse(localStorage?.getItem("stops_recent_searchCar"))
        : [];
      filteredRecentSearches = [recentSearch?.from, ...filteredRecentSearches];
      filteredRecentSearchesTo = [
        recentSearch?.to,
        ...filteredRecentSearchesTo,
      ];
      filteredRecentSearchesStops = [
        recentSearch?.stop,
        ...filteredRecentSearchesStops,
      ];
      let from_recent_serachCar = filteredRecentSearches
        .filter(
          (search, index, self) =>
            index === self.findIndex((s) => s?.name === search.name)
        )
        .slice(0, 5);
      let to_recent_serachCar = filteredRecentSearchesTo
        .filter(
          (search, index, self) =>
            index === self.findIndex((s) => s?.name === search.name)
        )
        .slice(0, 5);
      // let stop_recent_serachCar = filteredRecentSearchesStops.filter((search, index, self) => index === self.findIndex((s) => s?.code === search.code)).slice(0, 5);
      localStorage.setItem(
        "from_recent_searchCar",
        JSON.stringify(from_recent_serachCar)
      );
      localStorage.setItem(
        "to_recent_searchCar",
        JSON.stringify(to_recent_serachCar)
      );
      // localStorage.setItem("stop_recent_searchCar", JSON.stringify(stop_recent_serachCar));
      this.setState({
        fromRecent: from_recent_serachCar || [],
        toRecent: to_recent_serachCar || [],
        // stopsRecent: stop_recent_serachCar || []
      });
      let urlQuery = {
        from: this.state.srcValue,
        to: this.state.destValue,
        fromDate: this.state.departureDate,
        toDate: this.state.returnDate,
        stops: this.state.selectedDestinations,
        tripType: this.state.selectedTripType,
        tripTypeDetails: this.state.tripTypeDetails,
        packageId: this.state.packageId,
        pickupTime: this.state.time,
        dropTime: this.state.dropTime,
        distance: this.state.distance,
        selectedTab: this.state.selectedTab,
        bookingType: this.state.bookingTripId,

      };
      if (
        this.props?.userProfile?.type === "B2E" ||
        this.props?.userProfile?.type === "B2B"
      ) {
        urlQuery.guestId = this.state.guest_id;
        urlQuery.employeeGuest = this.state?.employeeguestId;
      }
      this.setState({
        btnClicked: true,
      });
      if (!this.props.isMobile) {
        urlQuery.selectedTab =
          this.state.selectedTripType == 3 || this.state.selectedTripType == 4
            ? this.state.selectedTripType
            : 0;
      }
      const queryString = this.serializeQuery(urlQuery);
      localStorage.setItem("car_srp", JSON.stringify(queryString));
      cf.redirectTo("car/search", queryString);
    }
  };

  onChangeDistance = (index) => {
    this.setState({ packageId: index });
  };

  apply = (key, value) => {
    this.updateErrMsg();
    this.setState({ [key]: value });
  };

  checkValidation = () => {
    let timeValidation = this.checkTimeValidation();
    let isValid = true;
    let isTimeValid = timeValidation;

    if (this.state.selectedTripType == 4) {
      isValid = this.state.srcValue !== "";
      this.setState((prev) => ({
        ...prev,
        errorMessage: {
          ...prev.errorMessage,
          srcErr: this.state.srcValue == "" ? "Enter origin city" : "",
        },
      }));
    } else {
      isValid =
        this.state.srcValue !== "" &&
        this.state.destValue !== "" &&
        this.state.srcValue?.code != this.state.destValue?.code;
      this.setState((prev) => ({
        ...prev,
        errorMessage: {
          ...prev.errorMessage,
          srcErr: this.state.srcValue == "" ? "Enter origin city" : "",
          destErr:
            this.state.destValue == ""
              ? "Enter destination city"
              : this.state.srcValue != "" &&
                this.state.destValue != "" &&
                this.state.srcValue?.code == this.state.destValue?.code
              ? "The Origin City & Destination City cannot be the same"
              : "",
        },
      }));
    }

    if (isValid && isTimeValid) {
      isValid = true;
    } else {
      isValid = false;
    }

    return isValid;
  };

  checkTimeValidation = () => {
    const currentDate = moment();
    const departureMoment = moment(this.state.departureDate, "DD-MMM-YYYY");
    const returnMoment = moment(this.state.returnDate, "DD-MMM-YYYY");
    const isSame = departureMoment.isSame(currentDate, "day");
    const isSameReturn = returnMoment.isSame(departureMoment, "day");
    const stateTimeMoment = moment(this.state.time, "hh:mm A");
    const currentTimeMoment = moment(currentTime, "hh:mm A");
    const stateDropTimeMoment = moment(this.state.dropTime, "hh:mm A");

    let errorMessage = {};
    let isValid = true;
    if (isSame && stateTimeMoment.isBefore(currentTimeMoment)) {
      errorMessage.pickTime = "Please select a valid time";
      isValid = false;
    } else {
      errorMessage.pickTime = "";
    }

    // stateDropTimeMoment.diff(stateTimeMoment, 'hours') < 4    drop time must greater than atleast 4 hours of pickup time
    if (
      this.state.selectedTripType === 2 &&
      isSameReturn &&
      !stateDropTimeMoment.isAfter(stateTimeMoment)
    ) {
      errorMessage.dropTime = "Return time should be more than pick time";
      isValid = false;
    } else {
      errorMessage.dropTime = "";
    }

    if (this.state.selectedTripType === 2) {
      if (errorMessage.pickTime || errorMessage.dropTime) {
        isValid = false;
      }
    } else if (errorMessage.pickTime) {
      isValid = false;
    }

    this.setState((prevState) => ({
      ...prevState,
      errorMessage: {
        ...prevState.errorMessage,
        ...errorMessage,
      },
    }));

    return isValid;
  };

  updateErrMsg = () => {
    this.setState((prevState) => ({
      ...prevState,
      errorMessage: {
        ...prevState.errorMessage,
        pickTime: "",
        dropTime: "",
      },
    }));
  };

  serializeQuery = (queryObj) => {
    const queryParts = Object.entries(queryObj).map(([key, value]) => {
      // If the value is an array or object, serialize it properly
      if (Array.isArray(value) || typeof value === "object") {
        return `${encodeURIComponent(key)}=${encodeURIComponent(
          JSON.stringify(value)
        )}`;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    });
    return queryParts.join("&");
  };

  handleAddDestination = () => {
    this.setState({ showAutoComplete: true });
    this.setState((prev) => ({
      ...prev,
      errorMessage: {
        ...prev.errorMessage,
        addStopsErr:
          this.state.selectedDestinations.length == 5
            ? "You can't add more than 5 stops"
            : "",
      },
    }));
  };

  handleSelectDestination = (value, type) => {
    this.setState((prev) => ({
      selectedDestinations: [...prev.selectedDestinations, value],
      showAutoComplete: false,
      stops: "",
    }));
  };

  handleRemoveDestination = (index) => {
    this.setState((prevState) => ({
      selectedDestinations: prevState.selectedDestinations.filter(
        (_, i) => i !== index
      ),
    }));
  };

  onClickSwap = () => {
    this.setState((prevState) => ({
      src: prevState.dest,
      dest: prevState.src,
      srcValue: prevState.destValue,
      destValue: prevState.srcValue,
      srcErr: prevState.dest ? "" : "Enter origin city",
      destErr: prevState.src ? "" : "Enter destination city",
    }));

    this.setState((prev) => ({
      ...prev,
      errorMessage: {
        ...prev.errorMessage,
        srcErr: "",
        destErr: "",
      },
    }));
  };

  onClickTraveller = () => {
    this.setState({ openTraveler: !this.state.openTraveler });
  };

  adGuestId = (id) => {
    this.setState({
      guest_id: id,
      isError: { ...this.state.isError, colleagueError: false },
    });
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
  };

  onClickClientNationality = (nationality, id, email, isAdd) => {
    if (isAdd) {
      let nationalityList = {
        value: nationality == null ? "" : nationality,
        countryCode: "",
      };
      this.setState({ selectedNationality: nationalityList });
      this.setState({ clientNationality: nationalityList });
    } else {
      let nationalityList = { value: "", countryCode: "" };
      this.setState({ selectedNationality: nationalityList });
      this.setState({ clientNationality: nationalityList });
    }
  };

  addEmployeeGuestId = (item) => {
    this.setState((prevState) => ({
      employeeguestId: [...prevState.employeeguestId, item],
    }));
  };

  removeEmployeeGuestId = (updatedId) => {
    this.setState({ employeeguestId: updatedId });
  };

  selectedTripId = (id) => {
    console.log("triptype log:this.props.bookingType==============", id);
    this.setState({ bookingTripId: id });    
  }

  render() {
    return (
      <>
        <div
          className={`${this.props.styles.flight_mobileContainer} ${
            this.props.isSRP
              ? this.props.styles.srpwidget
              : "container-1242 mx-auto"
          }`}
          ref={this.setDropdownWrapperRef}
        >

          {this.props?.isMobile &&
            (this.props?.userProfile?.type === "B2E" ||
              this.props?.userProfile?.type === "B2B") && (
              <div className={this.props.styles.mobile_header}>
                <div className={this.props.styles.mobile_visible}>
                  <div
                    className={
                      this.props.styles.mobo_tab_header +
                      " " +
                      this.props.styles.flight_header_mobo
                    }
                  >
                    {this.props.isSRP ? (
                      <span
                        onClick={() => this.props.onClosePopup(false)}
                        className={this.props.styles.arrow_image}
                      >
                        <svg
                          width="32px"
                          height="32px"
                          xmlns="http://www.w3.org/2000/svg"
                          data-name="Layer 1"
                          viewBox="0 0 24 24"
                          id="arrow-left"
                        >
                          <path
                            fill="#005A95"
                            d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"
                          ></path>
                        </svg>
                      </span>
                    ) : (
                      <span
                        onClick={() => this.props.onClosePopup(false)}
                        className={this.props.styles.arrow_image}
                      >
                        <svg
                          width="32px"
                          height="32px"
                          xmlns="http://www.w3.org/2000/svg"
                          data-name="Layer 1"
                          viewBox="0 0 24 24"
                          id="arrow-left"
                        >
                          <path
                            fill="#005A95"
                            d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"
                          ></path>
                        </svg>
                      </span>
                    )}
                    <h3 className={this.props.styles.search_filter_header}>
                      {" "}
                      {this.props.isSRP ? "Modify Cab Search" : "Cab"}
                    </h3>
                  </div>
                </div>
              </div>
            )}
          <div className={this.props.styles.car_searchwidget_container}>
            <div className={this.props.styles.car_searchwidget_wrap}>
              <div className={this.props.styles.car_way_tab}>
               {this.props?.userProfile?.type === "B2E"&&!this.props.isSRP&&<TripTypeSelector
                                        bookingType={this.state.bookingType}
                                        selectedTripId={(value)=>{this.selectedTripId(value)}}
                                        styles={this.props.styles}
                                        bookingTypeId={this.state.bookingTripId}

                                      />}
                {!this.props.isMobile ? (
                  <div
                    className={`${this.props.styles.car_way_btngrp} ${this.props.styles.flight_way_btngrp} ${this.props.styles.radio_cont}`}
                  >
                    {this.state.tripTypeArr.map((trip, id) => {
                      return (
                        <label
                          className={`${this.props.styles.radio_button} ${
                            trip.id == this.state.selectedTripType
                              ? this.props.styles.radio_active
                              : ""
                          }`}
                          onClick={() => {
                            this.onselectTrip(trip, id);
                          }}
                        >
                          <input
                            type="radio"
                            value={trip.value}
                            checked={trip.id == this.state.selectedTripType}
                          />
                          {trip.label}
                          <span></span>
                        </label>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    <div className={this.props.styles.tab_container}>
                      {this.state.tabs.map((tab) => (
                        <div
                          key={tab.id}
                          onClick={() => this.selectTab(tab)}
                          className={`${this.props.styles.tab} ${
                            this.state.selectedTab === tab.id
                              ? this.props.styles.active
                              : ""
                          }`}
                        >
                          {tab.label}
                        </div>
                      ))}
                    </div>
                    {this.state.selectedTab == 0 && (
                      <div
                        className={`${this.props.styles.car_way_btngrp} ${this.props.styles.flight_way_btngrp} ${this.props.styles.radio_cont}`}
                      >
                        {this.state.tabs?.[0]?.tripOptions.map((trip) => (
                          <label
                            key={trip.id}
                            className={`${this.props.styles.radio_button} ${
                              trip.id === this.state.selectedTripType
                                ? this.props.styles.radio_active
                                : ""
                            }`}
                            onClick={() => this.onselectTrip(trip)}
                          >
                            <input
                              type="radio"
                              value={trip.value}
                              checked={trip.id === this.state.selectedTripType}
                            />
                            {trip.label}
                            <span></span>
                          </label>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>

              {this.props?.userProfile?.type === "B2E" ||
              this.props?.userProfile?.type === "B2B" ? (
                <div
                  className={`${this.props.styles.hotelNationBtob}
                ${
                  this.props.isMobile &&
                  (this.state.selectedTripType == "3" ||
                    this.state.selectedTripType == "4")
                    ? this.props.styles.car_searchWidget_mob
                    : ""
                }
                `}
                >
                  <B2BWidgets
                    {...this.state}
                    theme="theme4"
                    styles={this.props.b2bStyles}
                    onClickTraveller={this.onClickTraveller}
                    // handleCheckboxSelection={this.handleCheckboxSelection}
                    addGuestId={this.adGuestId}
                    // guestDetail={this.guestDetail}
                    removeGuestId={this.rmGuestId}
                    // listWrapper={this.advanceSearchWrapper}
                    guestWrapper={this.guestDetailWrapper}
                    isOffline={this.props.isOffline}
                    errorMessage={
                      this.props.isOffline && this.state.guest_id == ""
                        ? "Select Traveler"
                        : ""
                    }
                    isError={this.state.isError.selectedGuest}
                    clientNationality={this.onClickClientNationality}
                    userProfile={this?.props?.userProfile}
                    isguestChecked={this.state.isguestChecked}
                    addEmployeeGuestId={this.addEmployeeGuestId}
                    removeEmployeeGuestId={this.removeEmployeeGuestId}
                    totalPax={1}
                    bookingTypeId={3}
                    getGuest={this.props.state}
                    isSRP={this.props.isSRP || false}
                  />
                </div>
              ) : null}

              <div
                className={`${this.props.styles.car_search_details_container}
              ${
                this.props.isMobile &&
                (this.state.selectedTripType == "3" ||
                  this.state.selectedTripType == "4")
                  ? this.props.styles.car_search_details_mob
                  : ""
              }
              ${
                this.props.isMobile && this.state.selectedTripType == "4"
                  ? this.props.styles.car_search_hourly
                  : ""
              }`}
              >
                <div className={`${this.props.styles.car_search_details_wrap}`}>
                  {this.state.selectedTripType == 3 && (
                    <div
                      className={
                        this.props.styles
                          .car_searchwidget_airport_selector_container
                      }
                    >
                      <AirportTransferSelector
                        styles={this.props.styles}
                        tripTypeDetails={this.state.tripTypeDetails}
                        apply={this.apply}
                        isMobile={this.props.isMobile}
                      />
                    </div>
                  )}
                  <div
                    className={this.props.styles.car_search_details_main}
                    onClick={() => {
                      this.props.isMobile && !this.state.showsrcDropdown
                        ? this.onclickFlightAutoComplete("src")
                        : null;
                    }}
                  >
                    <AutoComplete
                      label={
                        this.state.selectedTripType == "4"
                          ? "Pickup Location"
                          : "From"
                      }
                      value={this.state.src}
                      subTitle={this.state.srcValue}
                      onclickFlightAutoComplete={() =>
                        this.onclickFlightAutoComplete("src")
                      }
                      styles={this.props.styles}
                      state={this.state}
                      placholder="City or Airport"
                      onClickSourceAndDestination={(value) =>
                        this.onClickSetDepartureGoingToValue(value, "src")
                      }
                      onChangeSourceAndDestination={(value) =>
                        this.onChangeSetDepartureGoingToValue(value, "src")
                      }
                      isAutoCompleteExpand={(bool) => {
                        this.expandAutoComplete(bool, "src");
                      }}
                      autoCompleteData={
                        this.props.getDepartureSuggestionList || []
                      }
                      expandAutoCompleteBool={this.state.showsrcDropdown}
                      errorMessage={this.state.errorMessage.srcErr}
                      isError={this.state.errorMessage.srcErr ? true : false}
                      listWrapper={this.departureListWrapper}
                      id={0}
                      Header={"Source"}
                      isMobile={this.props?.isMobile}
                      popupClosed={() => {
                        this.popupClosed("src");
                      }}
                      selectedTripType={this.state.selectedTripType}
                      recentData={this.state?.fromRecent}
                      text={"src"}
                    />
                  </div>

                  {this.state.selectedTripType != 4 && (
                    <>
                      <span
                        className={this.props.styles.car_autocomplete_container}
                      >
                        <span
                          className={this.props.styles.car_searchwidget_icon}
                          onClick={this.onClickSwap}
                        >
                          <svg
                            version="1.1"
                            id="Layer_1"
                            x="0px"
                            y="0px"
                            width="200px"
                            height="200px"
                            viewBox="0 0 200 200"
                          >
                            <g>
                              <circle
                                fill="#FFFFFF"
                                cx="99.508"
                                cy="100.966"
                                r="86"
                              ></circle>
                              <path
                                fill="#266AAC"
                                d="M99.508,189.466c-48.799,0-88.5-39.701-88.5-88.5s39.701-88.5,88.5-88.5s88.5,39.701,88.5,88.5   S148.307,189.466,99.508,189.466z M99.508,17.466c-46.042,0-83.5,37.458-83.5,83.5s37.458,83.5,83.5,83.5s83.5-37.458,83.5-83.5   S145.55,17.466,99.508,17.466z"
                              ></path>
                            </g>
                            <g>
                              <g>
                                <g>
                                  <g>
                                    <path
                                      fill="#266AAC"
                                      d="M140.813,120.888c-0.031-0.026-0.054-0.055-0.08-0.082l-26.604-26.58      c-1.06-1.27-2.946-1.443-4.217-0.384c-1.271,1.06-1.44,2.946-0.384,4.216c0.119,0.135,0.248,0.262,0.384,0.381l21.508,21.507      H60.336c-1.654,0.087-2.924,1.498-2.838,3.15c0.081,1.535,1.305,2.758,2.838,2.838h71.083l-21.54,21.485      c-1.13,1.179-1.13,3.038,0,4.216c1.162,1.157,3.043,1.162,4.211,0l26.643-26.619      C141.895,123.897,141.934,122.05,140.813,120.888z M84.919,107.904c0.003,0.002,0.005,0.005,0.008,0.005      c1.162,1.162,3.045,1.162,4.208-0.005c1.125-1.177,1.125-3.03,0-4.211l-21.54-21.485h71.077      c1.535-0.084,2.757-1.306,2.845-2.833c0.086-1.654-1.189-3.07-2.845-3.157H67.596l21.505-21.506      c0.14-0.119,0.267-0.243,0.383-0.387c1.057-1.265,0.887-3.157-0.383-4.205c-1.268-1.062-3.157-0.889-4.213,0.378L58.283,77.081      c-0.027,0.019-0.054,0.051-0.081,0.076c-1.119,1.165-1.083,3.016,0.081,4.138L84.919,107.904z"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                              <g>
                                <g>
                                  <g>
                                    <path
                                      fill="#FFFFFF"
                                      d="M111.984,153.007L111.984,153.007c-0.928,0-1.801-0.361-2.457-1.016c-1.328-1.384-1.328-3.54-0.01-4.916      l20.692-20.641H60.336c-1.819-0.096-3.243-1.519-3.337-3.312c-0.101-1.927,1.385-3.575,3.311-3.677l69.902-0.001l-20.654-20.653      c-0.127-0.111-0.271-0.253-0.404-0.403c-1.24-1.491-1.039-3.698,0.438-4.931c0.627-0.522,1.42-0.81,2.234-0.81      c1.041,0,2.02,0.458,2.688,1.257l26.66,26.634c0.635,0.658,0.973,1.522,0.954,2.438c-0.019,0.912-0.392,1.766-1.049,2.398      l-26.636,26.613C113.785,152.646,112.912,153.007,111.984,153.007z M131.42,125.435h1.209l-22.396,22.34      c-0.939,0.98-0.939,2.527,0.008,3.517c0.461,0.458,1.084,0.716,1.744,0.716l0,0c0.662,0,1.283-0.258,1.754-0.725l26.641-26.619      c0.473-0.456,0.736-1.059,0.75-1.705s-0.229-1.259-0.676-1.725l0.279-0.428l-0.354,0.354l-26.604-26.58      c-0.902-1.076-2.523-1.203-3.543-0.353c-1.055,0.88-1.197,2.456-0.318,3.512c0.095,0.108,0.21,0.22,0.329,0.325l22.385,22.382      h-72.29c-1.35,0.071-2.411,1.25-2.338,2.625c0.067,1.28,1.084,2.297,2.365,2.364H131.42z M87.029,109.28L87.029,109.28      c-0.927,0-1.799-0.361-2.455-1.018v-0.002L57.93,81.648c-1.354-1.303-1.396-3.476-0.088-4.837      c0.075-0.075,0.114-0.11,0.152-0.137l26.54-26.528c0.634-0.764,1.612-1.222,2.652-1.222c0.816,0,1.61,0.289,2.236,0.813      c0.713,0.589,1.155,1.425,1.24,2.354c0.086,0.932-0.196,1.839-0.794,2.556c-0.131,0.162-0.279,0.308-0.443,0.447L68.802,75.719      h69.871c1.955,0.102,3.443,1.753,3.343,3.683c-0.102,1.788-1.526,3.208-3.314,3.306l-69.896,0.001l20.683,20.632      c1.32,1.387,1.32,3.539,0.008,4.91C88.833,108.917,87.958,109.28,87.029,109.28z M85.131,107.409h0.003l0.146,0.146      c0.935,0.935,2.565,0.935,3.5-0.004c0.935-0.979,0.935-2.524-0.007-3.515l-22.387-22.33h72.287      c1.252-0.069,2.271-1.084,2.345-2.361c0.071-1.376-0.992-2.557-2.371-2.629H66.39l22.358-22.36      c0.146-0.126,0.252-0.229,0.348-0.348c0.432-0.517,0.633-1.164,0.571-1.828c-0.061-0.661-0.375-1.257-0.884-1.677      c-1.022-0.857-2.665-0.702-3.511,0.313L58.637,77.434l-0.435-0.278l0.36,0.346c-0.926,0.964-0.896,2.503,0.067,3.431      L85.131,107.409z"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                      </span>
                      <div
                        className={this.props.styles.car_search_details_main}
                        onClick={() => {
                          this.props.isMobile && !this.state.showdestDropdown
                            ? this.onclickFlightAutoComplete("dest")
                            : null;
                        }}
                      >
                        <AutoComplete
                          label="To"
                          value={this.state.dest}
                          subTitle={this.state.destValue}
                          onclickFlightAutoComplete={() =>
                            this.onclickFlightAutoComplete("dest")
                          }
                          styles={this.props.styles}
                          state={this.state}
                          placholder="City or Airport"
                          onClickSourceAndDestination={(value) =>
                            this.onClickSetDepartureGoingToValue(value, "dest")
                          }
                          onChangeSourceAndDestination={(value) =>
                            this.onChangeSetDepartureGoingToValue(value, "dest")
                          }
                          isAutoCompleteExpand={(bool) => {
                            this.expandAutoComplete(bool, "dest");
                          }}
                          autoCompleteData={
                            this.props.getGoingToSuggestionList || []
                          }
                          expandAutoCompleteBool={this.state.showdestDropdown}
                          errorMessage={this.state.errorMessage.destErr}
                          isError={
                            this.state.errorMessage.destErr ? true : false
                          }
                          listWrapper={this.returnListWrapper}
                          id={0}
                          Header={"Destination"}
                          isMobile={this.props?.isMobile}
                          popupClosed={() => {
                            this.popupClosed("dest");
                          }}
                          selectedTripType={this.state.selectedTripType}
                          recentData={this.state?.toRecent}
                          text={"dest"}
                        />
                      </div>
                    </>
                  )}
                  {(this.state.selectedTripType == 1 ||
                    this.state.selectedTripType == 2) && (
                    <div
                      className={
                        this.props.styles.cab_stops_container_main_wrap
                      }
                    >
                      <div
                        className={this.props.styles.cab_stops_container_main}
                      >
                        <div className={this.props.styles.cab_stops_container}>
                          {!this.props.isMobile && (
                            <span className={this.props.styles.stops_label}>
                              {"Stops"}
                            </span>
                          )}

                          <div className={this.props.styles.cab_stops_wrap}>
                            {this.state.selectedDestinations &&
                              this.state.selectedDestinations.length > 0 && (
                                <span
                                  className={this.props.styles.stops_number}
                                >
                                  {"+"}
                                  {this.state.selectedDestinations.length}
                                </span>
                              )}
                            <div
                              className={this.props.styles.cab_seat_add_icon}
                            >
                              {this.props.isMobile && (
                                <span className={this.props.styles.stops_label}>
                                  {"Stops"}
                                </span>
                              )}
                              <div
                                className={
                                  this.props.styles.statusIndicatorPlus
                                }
                                onClick={this.handleAddDestination}
                              >
                                <span
                                  className={this.props.styles.statusDotPlus}
                                >
                                  <span
                                    className={this.props.styles.plusVertical}
                                  ></span>
                                  <span
                                    className={this.props.styles.plusHorizontal}
                                  ></span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${this.props.styles.cab_main_container}
                        ${
                          !this.state.showAutoComplete
                            ? this.props.styles.cab_main_border_hide
                            : ""
                        }`}
                            ref={this.stopsWrapper}
                          >
                            {(this.state.showAutoComplete ||
                              (this.state.selectedDestinations &&
                                this.state.selectedDestinations.length > 0 &&
                                this.props.isMobile)) &&
                              this.state.selectedDestinations.map(
                                (dest, index) => (
                                  <div
                                    className={
                                      this.props.styles.busStopContainer_main
                                    }
                                    key={index}
                                  >
                                    <div
                                      className={
                                        this.props.styles.busStopContainer
                                      }
                                    >
                                      <div
                                        className={
                                          this.props.styles.locationInfo
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="31"
                                          height="11"
                                          viewBox="0 0 31 11"
                                          fill="none"
                                        >
                                          <ellipse
                                            cx="15"
                                            cy="5.52834"
                                            rx="5"
                                            ry="5.4717"
                                            fill="#266AAC"
                                          />
                                          <rect
                                            y="4.43359"
                                            width="31"
                                            height="2.18868"
                                            fill="#266AAC"
                                          />
                                        </svg>
                                        <p
                                          className={
                                            this.props.styles.locationName
                                          }
                                        >
                                          {dest.name}
                                        </p>
                                      </div>
                                      <div
                                        className={
                                          this.props.styles.statusContainer
                                        }
                                        onClick={() =>
                                          this.handleRemoveDestination(index)
                                        }
                                      >
                                        <div
                                          className={
                                            this.props.styles.statusDivider
                                          }
                                        ></div>
                                        <div
                                          className={
                                            this.props.styles.statusIndicator
                                          }
                                        >
                                          <span
                                            className={
                                              this.props.styles.statusDot
                                            }
                                          ></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            <div className={this.props.styles.cabStop_main}>
                              <div className={this.props.styles.cabStop}>
                                <div
                                  className={this.props.styles.cabStopInfo}
                                  onClick={() => {
                                    this.props.isMobile &&
                                    !this.state.showstopsDropdown
                                      ? this.onclickFlightAutoComplete("stops")
                                      : null;
                                  }}
                                >
                                  {this.state.showAutoComplete &&
                                    this.state.selectedDestinations &&
                                    this.state.selectedDestinations.length <
                                      5 && (
                                      <AutoComplete
                                        label="Add stops"
                                        value={this.state.stops}
                                        onclickFlightAutoComplete={() =>
                                          this.onclickFlightAutoComplete(
                                            "stops"
                                          )
                                        }
                                        styles={this.props.styles}
                                        state={this.state}
                                        placholder="City or Airport"
                                        onClickSourceAndDestination={(value) =>
                                          this.handleSelectDestination(
                                            value,
                                            "stops"
                                          )
                                        }
                                        onChangeSourceAndDestination={(value) =>
                                          this.onChangeSetDepartureGoingToValue(
                                            value,
                                            "stops"
                                          )
                                        }
                                        isAutoCompleteExpand={(bool) => {
                                          this.expandAutoComplete(
                                            bool,
                                            "stops"
                                          );
                                        }}
                                        autoCompleteData={
                                          this.props
                                            .getCarStopsSuggestionList || []
                                        }
                                        expandAutoCompleteBool={
                                          this.state.showstopsDropdown
                                        }
                                        errorMessage={""}
                                        isError={false}
                                        listWrapper={this.travellerCabin}
                                        id={0}
                                        Header={"Add Stops"}
                                        isMobile={this.props?.isMobile}
                                        popupClosed={() => {
                                          this.popupClosed("stops");
                                        }}
                                        selectedTripType={
                                          this.state.selectedTripType
                                        }
                                        recentData={this.state?.stopsRecent}
                                        text={"stops"}
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                            {this.state.errorMessage.addStopsErr != "" && (
                              <div className={this.props.styles.cabStop_err}>
                                {this.state.errorMessage.addStopsErr}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    className={`${
                      this.props?.isMobile
                        ? this.props.styles.mobileflexcal
                        : this.props.styles.desktop_div
                    }
                ${
                  !this.props?.isMobile &&
                  (this.state.selectedTripType == "1" ||
                    this.state.selectedTripType == "2")
                    ? this.props.styles.calendar_width
                    : ""
                }`}
                  >
                    {!this.props.isMobile && (
                      <div
                        className={`${
                          this.props.styles.car_search_details_new_wrap
                        }
                    ${
                      this.state.selectedTripType != "1" &&
                      this.state.selectedTripType != "2"
                        ? this.props.styles
                            .car_search_details_new_wrap_onlyDepart
                        : ""
                    }`}
                        tabIndex={2}
                        ref={this.guestDetailWrapper}
                        onFocus={(e) => {
                          e.stopPropagation();
                          this.setState({ isdepartureCalendarVisible: true });
                        }}
                      >
                        <DesktopCalender
                          theme="theme5"
                          label="Departure"
                          iconImage={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                            >
                              <path
                                d="M24.3103 3.10345H23.2759V1.55172C23.2759 0.672414 22.6034 0 21.7241 0H20.6897C19.8103 0 19.1379 0.672414 19.1379 1.55172V3.10345H10.8621V1.55172C10.8621 0.672414 10.1897 0 9.31034 0H8.27586C7.39655 0 6.72414 0.672414 6.72414 1.55172V3.10345H5.68965C2.58621 3.10345 0.0517241 5.63793 0 8.74138V24.3103C0 24.6724 0.0517242 25.0862 0.103448 25.4483C0.672414 28.0862 3 30 5.68965 30H24.3103C27 30 29.3276 28.0862 29.8965 25.4483C29.9483 25.0862 30 24.6724 30 24.3103V8.68965C29.9483 5.63793 27.4138 3.10345 24.3103 3.10345ZM20.1724 1.55172C20.1724 1.24138 20.3793 1.03448 20.6897 1.03448H21.7241C22.0345 1.03448 22.2414 1.24138 22.2414 1.55172V5.68965C22.2414 6 22.0345 6.2069 21.7241 6.2069H20.6897C20.3793 6.2069 20.1724 6 20.1724 5.68965V1.55172ZM7.75862 1.55172C7.75862 1.24138 7.96552 1.03448 8.27586 1.03448H9.31034C9.62069 1.03448 9.82759 1.24138 9.82759 1.55172V5.68965C9.82759 6 9.62069 6.2069 9.31034 6.2069H8.27586C7.96552 6.2069 7.75862 6 7.75862 5.68965V1.55172ZM5.68965 28.9655C3.72414 28.9655 1.96552 27.6724 1.2931 25.8621H5.68965V28.9655ZM5.68965 24.8276H1.08621C1.03448 24.6724 1.03448 24.4655 1.03448 24.3103V20.3276H5.68965V24.8276ZM5.68965 19.2931H1.03448V14.7931H5.68965V19.2931ZM5.68965 13.7586H1.03448V9.25862H5.68965V13.7586ZM11.5345 28.9655H6.72414V25.8621H11.5345V28.9655ZM11.5345 24.8276H6.72414V20.3276H11.5345V24.8276ZM11.5345 19.2931H6.72414V14.7931H11.5345V19.2931ZM11.5345 13.7586H6.72414V9.25862H11.5345V13.7586ZM17.431 28.9655H12.6207V25.8621H17.431V28.9655ZM17.431 24.8276H12.6207V20.3276H17.431V24.8276ZM17.431 19.2931H12.6207V14.7931H17.431V19.2931ZM17.431 13.7586H12.6207V9.25862H17.431V13.7586ZM23.2759 28.9655H18.4655V25.8621H23.2759V28.9655ZM23.2759 24.8276H18.4655V20.3276H23.2759V24.8276ZM23.2759 19.2931H18.4655V14.7931H23.2759V19.2931ZM23.2759 13.7586H18.4655V9.25862H23.2759V13.7586ZM23.7931 8.22414H17.9483H12.0517H6.2069H1.08621C1.34483 5.89655 3.36207 4.13793 5.68965 4.13793H6.72414V5.68965C6.72414 6.56897 7.39655 7.24138 8.27586 7.24138H9.31034C10.1897 7.24138 10.8621 6.56897 10.8621 5.68965V4.13793H19.1379V5.68965C19.1379 6.56897 19.8103 7.24138 20.6897 7.24138H21.7241C22.6034 7.24138 23.2759 6.56897 23.2759 5.68965V4.13793H24.3103C26.6897 4.13793 28.6552 5.89655 28.9138 8.22414H23.7931ZM24.3103 28.9655V25.8621H28.7069C28.0345 27.6724 26.2759 28.9655 24.3103 28.9655ZM28.9655 24.3103C28.9655 24.4655 28.9655 24.6724 28.9138 24.8276H24.3103V20.3276H28.9655V24.3103ZM28.9655 19.2931H24.3103V14.7931H28.9655V19.2931ZM28.9655 13.7586H24.3103V9.25862H28.9655V13.7586Z"
                                fill="#266AAC"
                              />
                            </svg>
                          }
                          styles={this.props.styles}
                          value={this.state.departureDate}
                          isdepartureDateValue={true}
                          departureDate={this.state.departureDate}
                          onChangeDate={(value) => {
                            this.onChangeDepartureGoingDateValue(
                              value,
                              "departure"
                            );
                          }}
                          startDate={this.state.departureDate}
                          endDate={this.state.returnDate}
                          startDateLimit={this.state.disabledDate}
                          dateFormat={"DD-MMM-YYYY"}
                          changeVisibility={(bool) => {
                            this.onChangeVisibility(bool, "departure");
                          }}
                          isVisible={this.state.isdepartureCalendarVisible}
                          type={"double"}
                          doubleSelection={false}
                          weekDay={
                            weekday[new Date(this.state.departureDate).getDay()]
                          }
                          isReturnCalendar={false}
                        />
                      </div>
                    )}
                    {(this.state.selectedTripType == 1 ||
                      this.state.selectedTripType == 2) &&
                      !this.props.isMobile && (
                        <div
                          className={
                            this.props.styles
                              .car_searchwidget_calendar_container
                          }
                          tabIndex={2}
                          ref={this.guestDetailWrapper}
                          onFocus={(e) => {
                            e.stopPropagation();
                            // this.setState({ isreturnCalendarVisible: true });
                          }}
                        >
                          <DesktopCalender
                            label="Return"
                            iconImage={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <path
                                  d="M24.3103 3.10345H23.2759V1.55172C23.2759 0.672414 22.6034 0 21.7241 0H20.6897C19.8103 0 19.1379 0.672414 19.1379 1.55172V3.10345H10.8621V1.55172C10.8621 0.672414 10.1897 0 9.31034 0H8.27586C7.39655 0 6.72414 0.672414 6.72414 1.55172V3.10345H5.68965C2.58621 3.10345 0.0517241 5.63793 0 8.74138V24.3103C0 24.6724 0.0517242 25.0862 0.103448 25.4483C0.672414 28.0862 3 30 5.68965 30H24.3103C27 30 29.3276 28.0862 29.8965 25.4483C29.9483 25.0862 30 24.6724 30 24.3103V8.68965C29.9483 5.63793 27.4138 3.10345 24.3103 3.10345ZM20.1724 1.55172C20.1724 1.24138 20.3793 1.03448 20.6897 1.03448H21.7241C22.0345 1.03448 22.2414 1.24138 22.2414 1.55172V5.68965C22.2414 6 22.0345 6.2069 21.7241 6.2069H20.6897C20.3793 6.2069 20.1724 6 20.1724 5.68965V1.55172ZM7.75862 1.55172C7.75862 1.24138 7.96552 1.03448 8.27586 1.03448H9.31034C9.62069 1.03448 9.82759 1.24138 9.82759 1.55172V5.68965C9.82759 6 9.62069 6.2069 9.31034 6.2069H8.27586C7.96552 6.2069 7.75862 6 7.75862 5.68965V1.55172ZM5.68965 28.9655C3.72414 28.9655 1.96552 27.6724 1.2931 25.8621H5.68965V28.9655ZM5.68965 24.8276H1.08621C1.03448 24.6724 1.03448 24.4655 1.03448 24.3103V20.3276H5.68965V24.8276ZM5.68965 19.2931H1.03448V14.7931H5.68965V19.2931ZM5.68965 13.7586H1.03448V9.25862H5.68965V13.7586ZM11.5345 28.9655H6.72414V25.8621H11.5345V28.9655ZM11.5345 24.8276H6.72414V20.3276H11.5345V24.8276ZM11.5345 19.2931H6.72414V14.7931H11.5345V19.2931ZM11.5345 13.7586H6.72414V9.25862H11.5345V13.7586ZM17.431 28.9655H12.6207V25.8621H17.431V28.9655ZM17.431 24.8276H12.6207V20.3276H17.431V24.8276ZM17.431 19.2931H12.6207V14.7931H17.431V19.2931ZM17.431 13.7586H12.6207V9.25862H17.431V13.7586ZM23.2759 28.9655H18.4655V25.8621H23.2759V28.9655ZM23.2759 24.8276H18.4655V20.3276H23.2759V24.8276ZM23.2759 19.2931H18.4655V14.7931H23.2759V19.2931ZM23.2759 13.7586H18.4655V9.25862H23.2759V13.7586ZM23.7931 8.22414H17.9483H12.0517H6.2069H1.08621C1.34483 5.89655 3.36207 4.13793 5.68965 4.13793H6.72414V5.68965C6.72414 6.56897 7.39655 7.24138 8.27586 7.24138H9.31034C10.1897 7.24138 10.8621 6.56897 10.8621 5.68965V4.13793H19.1379V5.68965C19.1379 6.56897 19.8103 7.24138 20.6897 7.24138H21.7241C22.6034 7.24138 23.2759 6.56897 23.2759 5.68965V4.13793H24.3103C26.6897 4.13793 28.6552 5.89655 28.9138 8.22414H23.7931ZM24.3103 28.9655V25.8621H28.7069C28.0345 27.6724 26.2759 28.9655 24.3103 28.9655ZM28.9655 24.3103C28.9655 24.4655 28.9655 24.6724 28.9138 24.8276H24.3103V20.3276H28.9655V24.3103ZM28.9655 19.2931H24.3103V14.7931H28.9655V19.2931ZM28.9655 13.7586H24.3103V9.25862H28.9655V13.7586Z"
                                  fill="#266AAC"
                                />
                              </svg>
                            }
                            styles={this.props.styles}
                            value={this.state.returnDate || ""}
                            isgoingToDateValue={true}
                            departureDate={this.state.returnDate}
                            onChangeDate={(value) => {
                              this.onChangeDepartureGoingDateValue(
                                value,
                                "return"
                              );
                            }}
                            startDate={this.state.departureDate || ""}
                            endDate={this.state.returnDate || ""}
                            startDateLimit={
                              this.state.departureDate
                                ? this.state.departureDate
                                : this.state.disabledDate
                                ? this.state.disabledDate
                                : todaysDate
                            }
                            dateFormat={"DD-MMM-YYYY"}
                            changeVisibility={(bool) => {
                              this.onChangeVisibility(bool, "return");
                            }}
                            isVisible={this.state.isreturnCalendarVisible}
                            type={"double"}
                            doubleSelection={false}
                            DisableReturnDate={
                              this.state.selectedTripType == "1"
                            }
                            triptype={this.state.selectedTripType}
                            selectTripbtn={() => {
                              this.onselectTrip({
                                id: 2,
                                value: "roundTrip",
                                label: "Outstation Round-Trip",
                              });
                            }}
                            weekDay={
                              weekday[new Date(this.state.returnDate).getDay()]
                            }
                            roundWayReturnClick={() => {
                              this.onselectTrip(
                                {
                                  id: 1,
                                  value: "oneWay",
                                  label: "Outstation One-Way",
                                },
                                0
                              );
                            }}
                            showCrossIcon={
                              this.state.selectedTripType == "2" ? true : false
                            }
                            isReturnCalendar={true}
                          />
                        </div>
                      )}
                  </div>
                  {!this.props.isMobile && (
                    <>
                      <div
                        className={
                          this.props.styles.car_searchwidget_pickup_container
                        }
                      >
                        <PickupTime
                          styles={this.props.styles}
                          time={this.state.time}
                          pickTime={this.state.time}
                          apply={this.apply}
                          key={"time"}
                          label={"Pickup Time"}
                          type="time"
                          selectedDate={this.state.departureDate}
                          dropTime={this.state.dropTime}
                        />
                        <div
                          className={`${this.props.styles.cabStop_err} ${this.props.styles.pick_error}`}
                        >
                          {this.state.errorMessage.pickTime}
                        </div>
                      </div>
                      {this.state.selectedTripType == 2 && (
                        <div
                          className={
                            this.props.styles.car_searchwidget_pickup_container
                          }
                        >
                          <PickupTime
                            styles={this.props.styles}
                            time={this.state.dropTime}
                            dropTime={this.state.dropTime}
                            apply={this.apply}
                            key={"dropTime"}
                            label={"Return Time"}
                            type="dropTime"
                            selectedDate={this.state.returnDate}
                            errMsg={this.state.errorMessage.dropTime}
                            pickTime={this.state.time}
                          />
                          <div
                            className={`${this.props.styles.cabStop_err} ${this.props.styles.pick_error}`}
                          >
                            {this.state.errorMessage.dropTime}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {this.props.isMobile && (
                    <>
                      <TimePicker
                        Header={"Select Pick-up date & Time"}
                        styles={this.props.styles}
                        label={"Departure Date & Time"}
                        expandAutoCompleteBool={
                          this.state.showdatepickupDropdown
                        }
                        isAutoCompleteExpand={(bool) => {
                          this.expandAutoComplete(bool, "datePickup");
                        }}
                        popupClosed={() => this.popupClosed("datepickup")}
                        subTitle={"Pickup Date & Time"}
                        type={"departureDate"}
                        timeType={"time"}
                        value={this.state.departureDate}
                        time={this.state.time}
                        apply={this.apply}
                        onChangeDate={(value) => {
                          this.onChangeDepartureGoingDateValue(
                            value,
                            "departure"
                          );
                        }}
                      />
                      <div className={this.props.styles.cabStop_err}>
                        {this.state.errorMessage.pickTime}
                      </div>

                      {this.state.selectedTripType == 2 && (
                        <TimePicker
                          Header={"Select Drop date & time"}
                          styles={this.props.styles}
                          label={"Return Date & Time"}
                          expandAutoCompleteBool={
                            this.state.showdatedropDropdown
                          }
                          isAutoCompleteExpand={(bool) => {
                            this.expandAutoComplete(bool, "dateDrop");
                          }}
                          popupClosed={() => this.popupClosed("datedrop")}
                          subTitle={"Drop Date & Time"}
                          type={"returnDate"}
                          timeType={"dropTime"}
                          value={this.state.returnDate}
                          time={this.state.dropTime}
                          apply={this.apply}
                          onChangeDate={(value) => {
                            this.onChangeDepartureGoingDateValue(
                              value,
                              "return"
                            );
                          }}
                        />
                      )}
                      <div className={this.props.styles.cabStop_err}>
                        {this.state.errorMessage.dropTime}
                      </div>
                    </>
                  )}
                  {this.state.selectedTripType == 4 && (
                    <div
                      className={
                        this.props.styles.car_searchwidget_distance_container
                      }
                    >
                      <DistanceList
                        styles={this.props.styles}
                        count={12}
                        onChangeDistance={this.onChangeDistance}
                        apply={this.apply}
                        distance={this.state.distance}
                        packageId={this.state.packageId}
                        isMobile={this.props.isMobile}
                        popupClosed={() => this.popupClosed("distance")}
                        isAutoCompleteExpand={(bool) => {
                          this.expandAutoComplete(bool, "distance");
                        }}
                        expandAutoCompleteBool={this.state.showdistanceDropdown}
                        header={"Selected Package"}
                        headerTitle={"Select Package"}
                      />
                    </div>
                  )}
                  <div className={this.props.styles.car_button_wrap}>
                    <button
                      className={
                        this.state?.btnClicked
                          ? `${this.props.styles.car_button} loading`
                          : this.props.styles.car_button
                      }
                      onClick={this.onClickSearchCar}
                    >
                      {"Search"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
